/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)


import moduleAuth from './auth/moduleAuth.js'
import setupState from './setup/moduleSetup.js'
import dashState from './dash_general/moduleDash.js'
import dashSurvey from './dash_surveyflow/moduleSurvey.js'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    signUpState: setupState,
    auth: moduleAuth,
    dash: dashState,
    survey: dashSurvey
  },
  strict: process.env.NODE_ENV !== 'production'
})
